/// <amd-module name="Wit/WorkItemForm/Common/Hooks/ControlDefaultOptionsContext" />
import * as React from "react";

export interface IControlDefaultOptionsContext {
    showChromeBorder: boolean;
    showEmptyReadOnlyFields: boolean;
}

export const ControlDefaultOptionsContext: React.Context<IControlDefaultOptionsContext> = React.createContext<IControlDefaultOptionsContext>({
    showChromeBorder: false,
    showEmptyReadOnlyFields: false
});
